var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g2, _g3, _path1, _path10, _path11, _path12, _g4, _path13, _path14, _path15, _path16, _path17, _g5, _path18, _g6, _path19, _g7, _g8, _ellipse, _ellipse2, _g9, _path20, _ellipse3, _ellipse4, _g0, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgLogoPlatform = function SvgLogoPlatform(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 125",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.4504 66.9805C87.8292 66.6176 87.061 66.6163 86.4385 66.9771L59.2227 82.7539L87.4454 100.004L115.793 82.9531L88.4504 66.9805Z",
    fill: "url(#logo-platform_svg__paint0_linear_10099_8207)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.043 89.9284V83.4133C116.043 83.0241 115.618 82.7841 115.285 82.9853L87.9247 99.5057C87.6081 99.6969 87.2118 99.6977 86.8943 99.5077L61.875 84.5352V92.6602L86.6383 107.506C87.1134 107.791 87.7068 107.791 88.1817 107.506L115.315 91.2144C115.767 90.9432 116.043 90.4551 116.043 89.9284Z",
    fill: "#6272A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.012 89.9284V83.4133C116.012 83.0241 115.587 82.7841 115.253 82.9853L87.862 99.5247C87.5622 99.7057 87.3789 100.03 87.3789 100.381V105.319C87.3789 106.485 88.6513 107.205 89.651 106.605L115.284 91.2144C115.735 90.9432 116.012 90.4551 116.012 89.9284Z",
    fill: "url(#logo-platform_svg__paint1_linear_10099_8207)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter0_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.4102 99.7871L87.3789 107.406",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8824 66.2297C37.494 65.9004 38.2326 65.9121 38.8336 66.2604L66.0893 82.0603L37.8666 99.3103L8.6875 81.4099L36.8824 66.2297Z",
    fill: "url(#logo-platform_svg__paint2_linear_10099_8207)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5625 88.4454V81.9308C8.5625 81.5395 8.99177 81.2998 9.3249 81.5052L37.3785 98.8004C37.6995 98.9983 38.1045 98.9988 38.426 98.8016L62.1875 84.2305V92.4727L38.6849 106.798C38.2042 107.091 37.6 107.09 37.1201 106.796L9.2784 89.7241C8.83361 89.4514 8.5625 88.9671 8.5625 88.4454Z",
    fill: "#6272A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 88.3832V81.8686C8.5 81.4772 8.9294 81.2376 9.26252 81.4431L37.4464 98.83C37.7416 99.0122 37.9214 99.3342 37.9214 99.6811V104.595C37.9214 105.768 36.6364 106.487 35.6369 105.874L9.21552 89.6617C8.77095 89.3889 8.5 88.9048 8.5 88.3832Z",
    fill: "url(#logo-platform_svg__paint3_linear_10099_8207)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7723 51.3555C48.3935 50.9926 49.1617 50.9913 49.7841 51.3521L77 67.1289L48.7772 84.3789L20.4297 67.3281L47.7723 51.3555Z",
    fill: "url(#logo-platform_svg__paint4_linear_10099_8207)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1797 74.3034V67.7883C20.1797 67.3991 20.6049 67.1591 20.9381 67.3603L48.2903 83.8761C48.611 84.0697 49.0129 84.0679 49.3318 83.8714L61.4252 76.419C61.7583 76.2137 62.1875 76.4534 62.1875 76.8447V83.349C62.1875 83.8722 61.9149 84.3576 61.4682 84.6298L49.5873 91.8715C49.111 92.1618 48.5128 92.1638 48.0345 91.8766L20.9076 75.5894C20.456 75.3182 20.1797 74.8301 20.1797 74.3034Z",
    fill: "#6272A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.466 84.6607L48.8125 92.3438L48.8242 84.2227L61.425 76.4507C61.7581 76.2453 62.1875 76.4849 62.1875 76.8763V83.3786C62.1875 83.9027 61.914 84.3887 61.466 84.6607Z",
    fill: "url(#logo-platform_svg__paint5_linear_10099_8207)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1992 74.3034V67.7883C20.1992 67.3991 20.6244 67.1591 20.9577 67.3603L48.3489 83.8997C48.6488 84.0807 48.832 84.4055 48.832 84.7557V89.6935C48.832 90.8597 47.5597 91.5798 46.5599 90.9795L20.9271 75.5894C20.4755 75.3182 20.1992 74.8301 20.1992 74.3034Z",
    fill: "url(#logo-platform_svg__paint6_linear_10099_8207)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter1_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8125 84.1621L48.8437 91.7811",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter2_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7729 99.1621L37.8042 106.781",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7492 51.3555C75.128 50.9926 74.3598 50.9913 73.7374 51.3521L46.5215 67.1289L74.7443 84.3789L103.092 67.3281L75.7492 51.3555Z",
    fill: "url(#logo-platform_svg__paint7_linear_10099_8207)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.342 74.3034V67.7883C103.342 67.3991 102.917 67.1591 102.583 67.3603L75.2312 83.8761C74.9105 84.0697 74.5086 84.0679 74.1897 83.8714L62.0963 76.419C61.7632 76.2137 61.334 76.4534 61.334 76.8447V83.349C61.334 83.8722 61.6066 84.3576 62.0533 84.6298L73.9341 91.8715C74.4105 92.1618 75.0087 92.1638 75.487 91.8766L102.614 75.5894C103.066 75.3182 103.342 74.8301 103.342 74.3034Z",
    fill: "#6272A2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0555 84.6607L74.709 92.3438L74.6973 84.2227L62.0965 76.4507C61.7633 76.2453 61.334 76.4849 61.334 76.8763V83.3786C61.334 83.9027 61.6075 84.3887 62.0555 84.6607Z",
    fill: "url(#logo-platform_svg__paint8_linear_10099_8207)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.322 74.3034V67.7883C103.322 67.3991 102.897 67.1591 102.564 67.3603L75.1726 83.8997C74.8727 84.0807 74.6895 84.4055 74.6895 84.7557V89.6935C74.6895 90.8597 75.9618 91.5798 76.9616 90.9795L102.594 75.5894C103.046 75.3182 103.322 74.8301 103.322 74.3034Z",
    fill: "url(#logo-platform_svg__paint9_linear_10099_8207)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter3_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.709 84.1621L74.6777 91.7811",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0899 35.6735C60.7125 35.3098 61.4828 35.3094 62.1058 35.6725L89.5781 51.6836L61.0975 67.3605L32.75 51.6445L60.0899 35.6735Z",
    fill: "url(#logo-platform_svg__paint10_linear_10099_8207)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1123 36.0601C60.7336 35.701 61.4997 35.7023 62.1198 36.0636L88.5703 51.4727C88.5703 51.4727 71.8809 46.7227 61.1171 46.7227C50.3532 46.7227 33.4453 51.4727 33.4453 51.4727L60.1123 36.0601Z",
    fill: "url(#logo-platform_svg__paint11_linear_10099_8207)",
    fillOpacity: 0.7
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 58.6198V52.0727C32.5 51.6905 32.9114 51.4496 33.2447 51.6366L60.655 67.0183C60.959 67.1889 61.33 67.1888 61.634 67.0182L89.0208 51.6408C89.3541 51.4537 89.7656 51.6946 89.7656 52.0768V58.616C89.7656 59.1426 89.4894 59.6307 89.0379 59.9019L61.905 76.1964C61.4298 76.4818 60.8359 76.4819 60.3606 76.1965L33.2279 59.9058C32.7763 59.6346 32.5 59.1465 32.5 58.6198Z",
    fill: "#6272A2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0379 59.9019L61.1328 76.6602L61.1445 67.293L89.0208 51.6408C89.3541 51.4537 89.7656 51.6946 89.7656 52.0768V58.616C89.7656 59.1426 89.4894 59.6307 89.0379 59.9019Z",
    fill: "url(#logo-platform_svg__paint12_linear_10099_8207)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5195 58.6198V52.0727C32.5195 51.6905 32.9309 51.4496 33.2642 51.6366L60.6527 67.006C60.9685 67.1832 61.1638 67.5173 61.1633 67.8793L61.1557 74.0138C61.1542 75.1791 59.8826 75.8978 58.8835 75.2979L33.2474 59.9058C32.7958 59.6346 32.5195 59.1465 32.5195 58.6198Z",
    fill: "url(#logo-platform_svg__paint13_linear_10099_8207)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter4_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1328 67.3477L61.1641 76.0976",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-platform_svg__mask0_10099_8207",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 76,
    width: 24,
    height: 16
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2708 76.5071L50.6562 83.0352V91.2227L61.8438 84.4727L73.5 91.5352L73.75 83.5977L62.3217 76.5091C62 76.3096 61.5932 76.3088 61.2708 76.5071Z",
    fill: "#C4C4C4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-platform_svg__mask0_10099_8207)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter5_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.9531,
    y: 73.4727,
    width: 9.96875,
    height: 17.8086,
    fill: "#1D1647",
    fillOpacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter6_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7812 74.7539V85.4727",
    stroke: "black",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-platform_svg__mask1_10099_8207",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 84,
    width: 24,
    height: 16
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2708 84.5071L50.6562 91.0352V99.2227L61.8438 92.4727L73.5 99.5352L73.75 91.5977L62.3217 84.5091C62 84.3096 61.5932 84.3088 61.2708 84.5071Z",
    fill: "#C4C4C4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-platform_svg__mask1_10099_8207)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter7_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.9531,
    y: 81.4727,
    width: 9.96875,
    height: 17.8086,
    fill: "#1D1647",
    fillOpacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter8_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7812 82.7539V93.4727",
    stroke: "black",
    strokeWidth: 0.5
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter9_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.7607,
    cy: 55.2119,
    rx: 10.602,
    ry: 3.54785,
    fill: "black",
    fillOpacity: 0.5
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.4023,
    cy: 32,
    rx: 18.0978,
    ry: 18,
    fill: "url(#logo-platform_svg__paint14_linear_10099_8207)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-platform_svg__mask2_10099_8207",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 14,
    width: 37,
    height: 36
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.402,
    cy: 32,
    rx: 18.0978,
    ry: 18,
    fill: "url(#logo-platform_svg__paint15_linear_10099_8207)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-platform_svg__mask2_10099_8207)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter10_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.1511 39.0048C69.1583 45.0583 69.879 26.1664 64.2271 20.6314C58.5751 15.0964 48.6907 25.0144 54.6835 18.9609C60.6763 12.9073 70.1163 12.487 75.7682 18.022C81.4202 23.5569 81.1439 32.9513 75.1511 39.0048Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter11_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7985 21.2215C80.9993 27.8609 60.3868 26.3624 54.9542 32.1909C49.5215 38.0194 61.326 48.9677 54.1251 42.3283C46.9243 35.6889 45.491 25.5817 50.9236 19.7532C56.3563 13.9247 66.5977 14.5821 73.7985 21.2215Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter12_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1534 41.5279C47.6164 38.0331 58.0607 45.2464 64.9974 46.1555C71.934 47.0646 72.7362 41.3253 72.2732 44.8201C71.8102 48.3149 65.8116 50.411 58.8749 49.5019C51.9383 48.5928 46.6903 45.0227 47.1534 41.5279Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter13_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.7894 36.9556C71.8179 46.3817 65.1537 30.0449 60.0397 29.5235C54.9256 29.0021 53.2983 44.4934 54.2699 35.0674C55.2414 25.6413 60.1748 18.4227 65.2888 18.9441C70.4029 19.4656 73.761 27.5296 72.7894 36.9556Z",
    fill: "#91EEFF"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3954 15.5325C58.4956 14.7703 46.6341 17.3903 46.3866 33.9681C47.5118 28.4096 52.6889 16.9404 64.3954 15.5325Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.2303,
    cy: 31.8389,
    rx: 3.89201,
    ry: 4,
    transform: "rotate(-180 62.2303 31.8389)",
    fill: "url(#logo-platform_svg__paint16_linear_10099_8207)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-platform_svg__mask3_10099_8207",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 27,
    width: 9,
    height: 9
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.2303,
    cy: 31.8389,
    rx: 3.89201,
    ry: 4,
    transform: "rotate(-180 62.2303 31.8389)",
    fill: "url(#logo-platform_svg__paint17_linear_10099_8207)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-platform_svg__mask3_10099_8207)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter14_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4885 30.2824C60.7773 28.9372 60.6223 33.1354 61.8378 34.3654C63.0533 35.5954 65.179 33.3914 63.8902 34.7366C62.6014 36.0818 60.5713 36.1753 59.3558 34.9453C58.1403 33.7153 58.1998 31.6276 59.4885 30.2824Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter15_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7795 34.2343C58.2309 32.7588 62.6637 33.0918 63.832 31.7966C65.0003 30.5014 62.4617 28.0684 64.0103 29.5438C65.5589 31.0193 65.8671 33.2653 64.6988 34.5605C63.5305 35.8558 61.328 35.7097 59.7795 34.2343Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter16_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5094 29.7213C65.4098 30.4979 63.1637 28.895 61.672 28.6929C60.1802 28.4909 60.0077 29.7663 60.1073 28.9897C60.2069 28.2131 61.4969 27.7473 62.9887 27.9493C64.4804 28.1513 65.609 28.9447 65.5094 29.7213Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-platform_svg__filter17_f_10099_8207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9964 30.7373C60.2054 28.6427 61.6385 32.2731 62.7383 32.3889C63.8381 32.5048 64.1881 29.0623 63.9791 31.157C63.7702 33.2516 62.7093 34.8558 61.6095 34.7399C60.5097 34.624 59.7875 32.832 59.9964 30.7373Z",
    fill: "#91EEFF"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8882 35.4983C63.157 35.6677 65.7078 35.0855 65.7611 31.4015C65.5191 32.6367 64.4057 35.1854 61.8882 35.4983Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter0_f_10099_8207",
    x: 85.6289,
    y: 98.2861,
    width: 3.53125,
    height: 10.6211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter1_f_10099_8207",
    x: 47.0625,
    y: 82.6611,
    width: 3.53125,
    height: 10.6211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter2_f_10099_8207",
    x: 36.0229,
    y: 97.6611,
    width: 3.53125,
    height: 10.6211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter3_f_10099_8207",
    x: 72.9277,
    y: 82.6611,
    width: 3.53125,
    height: 10.6211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter4_f_10099_8207",
    x: 59.3828,
    y: 65.8467,
    width: 3.53125,
    height: 11.752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter5_f_10099_8207",
    x: 48.9531,
    y: 65.4727,
    width: 25.9688,
    height: 33.8086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter6_f_10099_8207",
    x: 60.0312,
    y: 73.2539,
    width: 3.5,
    height: 13.7188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter7_f_10099_8207",
    x: 48.9531,
    y: 73.4727,
    width: 25.9688,
    height: 33.8086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter8_f_10099_8207",
    x: 60.0312,
    y: 81.2539,
    width: 3.5,
    height: 13.7188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter9_f_10099_8207",
    x: 43.6587,
    y: 44.1641,
    width: 36.204,
    height: 22.0957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter10_f_10099_8207",
    x: 47.189,
    y: 8.50042,
    width: 38.2743,
    height: 37.317,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter11_f_10099_8207",
    x: 41.9979,
    y: 10.1474,
    width: 38.9402,
    height: 39.8815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter12_f_10099_8207",
    x: 41.4944,
    y: 34.9482,
    width: 36.516,
    height: 20.3961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter13_f_10099_8207",
    x: 36.3074,
    y: 1.22183,
    width: 54.345,
    height: 56.3532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.84783,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter14_f_10099_8207",
    x: 52.8513,
    y: 24.3891,
    width: 17.0702,
    height: 17.0514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter15_f_10099_8207",
    x: 53.8245,
    y: 23.4535,
    width: 17.2134,
    height: 17.6207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter16_f_10099_8207",
    x: 54.4539,
    y: 22.2719,
    width: 16.692,
    height: 13.2907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.81522,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-platform_svg__filter17_f_10099_8207",
    x: 42.2648,
    y: 12.3922,
    width: 39.4674,
    height: 40.049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.84783,
    result: "effect1_foregroundBlur_10099_8207"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint0_linear_10099_8207",
    x1: 93.3887,
    y1: 82.0977,
    x2: 99.4512,
    y2: 91.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6171C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint1_linear_10099_8207",
    x1: 116.012,
    y1: 86.1563,
    x2: 89.1289,
    y2: 101.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068939,
    stopColor: "#4C579B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CE7D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint2_linear_10099_8207",
    x1: 24.5893,
    y1: 92.7166,
    x2: 31.2143,
    y2: 81.0916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint3_linear_10099_8207",
    x1: 9.28857,
    y1: 85.4629,
    x2: 36.1714,
    y2: 100.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068939,
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91EEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint4_linear_10099_8207",
    x1: 35.5,
    y1: 77.7852,
    x2: 42.125,
    y2: 66.1602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint5_linear_10099_8207",
    x1: 77.4453,
    y1: 71.0176,
    x2: 52.0344,
    y2: 85.4919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068939,
    stopColor: "#91EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CE7D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint6_linear_10099_8207",
    x1: 20.1992,
    y1: 70.5313,
    x2: 47.082,
    y2: 85.9062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068939,
    stopColor: "#4C579B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CE7D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint7_linear_10099_8207",
    x1: 80.6875,
    y1: 66.4727,
    x2: 86.75,
    y2: 76.2227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6171C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint8_linear_10099_8207",
    x1: 46.0762,
    y1: 71.0176,
    x2: 71.4871,
    y2: 85.4919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068939,
    stopColor: "#91EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CE7D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint9_linear_10099_8207",
    x1: 103.322,
    y1: 70.5313,
    x2: 76.4395,
    y2: 85.9062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068939,
    stopColor: "#4C579B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CE7D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint10_linear_10099_8207",
    x1: 49.5078,
    y1: 40.2227,
    x2: 72.0078,
    y2: 60.9727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6171C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint11_linear_10099_8207",
    x1: 21.0703,
    y1: 50.5977,
    x2: 83.1953,
    y2: 49.7227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint12_linear_10099_8207",
    x1: 89.7656,
    y1: 55.334,
    x2: 64.3548,
    y2: 69.8083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068939,
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91EEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint13_linear_10099_8207",
    x1: 32.5195,
    y1: 54.8477,
    x2: 59.4023,
    y2: 70.2227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068939,
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91EEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint14_linear_10099_8207",
    x1: 62.4023,
    y1: 14,
    x2: 62.4023,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint15_linear_10099_8207",
    x1: 62.402,
    y1: 14,
    x2: 62.402,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint16_linear_10099_8207",
    x1: 62.2303,
    y1: 27.8389,
    x2: 62.2303,
    y2: 35.8389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-platform_svg__paint17_linear_10099_8207",
    x1: 62.2303,
    y1: 27.8389,
    x2: 62.2303,
    y2: 35.8389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoPlatform);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "static/logo-platform.ee48c578.svg";